// extracted by mini-css-extract-plugin
module.exports = {"teaser":"teaser_teaser__PsnU4"};